import { styled } from "@mui/material/styles";

interface Props {
  checkColumn?: boolean;
  spacingColumns?: string;
  isOnViewMode?: boolean;
  hasErrors?: boolean;
}

export const Wrapper = styled("div")(() => ({
  height: "100%",
}));

export const TableBodyWrapper = styled("div", {
  shouldForwardProp: (props) =>
    props !== "checkColumn" && props !== "spacingColumns" && props !== "isOnViewMode",
})(({ checkColumn, spacingColumns, isOnViewMode, hasErrors = false }: Props) => ({
  display: "grid",
  alignItems: hasErrors ? "flex-start" : "center",
  columnGap: "1rem",
  padding: "6px 12px",
  gridTemplateColumns: `${checkColumn ? "2rem" : ""} ${spacingColumns} ${
    isOnViewMode ? "" : "4rem"
  }`,
}));

export const TableBodyEmptyGrid = styled("div")(() => ({
  background: "#f9fafb",
  width: "100%",
  borderRadius: 8,
  marginTop: 12,
  padding: "6px 12px",
  "& span": {
    color: "#465869",
    fontSize: 12,
    lineHeight: "18px",
  },
}));
